import script from "./Vacancy.vue?vue&type=script&setup=true&lang=js"
export * from "./Vacancy.vue?vue&type=script&setup=true&lang=js"

import "./Vacancy.vue?vue&type=style&index=0&id=4223f3f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4223f3f9"]])

export default __exports__